'use client';

import { createContext } from 'react';

import type { PopoverRootContextInterface } from '../types/popover-root.types';

export const PopoverRootContext = createContext({} as PopoverRootContextInterface);

PopoverRootContext.displayName = 'Popover.Root.Context';
